import { render, staticRenderFns } from "./page-pv.vue?vue&type=template&id=47dc2578&"
import script from "./page-pv.vue?vue&type=script&lang=js&"
export * from "./page-pv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports